import { FC } from 'react';

const TGOnlinesIcon: FC = () => (
    <svg width="37" height="30" viewBox="0 0 37 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M36 1L1 14.8158L13.8947 16.6579M36 1L31.3947 28.6316L13.8947 16.6579M36 1L13.8947 16.6579M13.8947 16.6579V26.7895L19.8794 20.7527" stroke="#909090" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

export default TGOnlinesIcon;import { FC } from 'react';

const TGOnlinesIcon: FC = () => (
    <svg width="37" height="30" viewBox="0 0 37 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M36 1L1 14.8158L13.8947 16.6579M36 1L31.3947 28.6316L13.8947 16.6579M36 1L13.8947 16.6579M13.8947 16.6579V26.7895L19.8794 20.7527" stroke="#909090" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

export default TGOnlinesIcon;